import React, { useCallback, useEffect, useState } from "react";
import { Card, CardBody, Col, Container, FormFeedback, Input, Label, Row, Table } from "reactstrap";
import Breadcrumbs from "components/Common/BreadcrumbTitle"
import { useFormik, FormikProvider, Form, FieldArray, } from "formik"
import { getAllDropDownValues, getDropDownList } from "http/fundLync/dropdown.helper";
import * as Yup from "yup"
import Select from "react-select"
import { allFinancier } from "http/fundLync/deal.helper";
import { decryptedValue, uId } from "common/utility";
import { getIndustry } from "http/fundLync/industryType.helper";
import CommonDialog from "components/Common/CommonDialog";
import { getFinancierPref, submitFinancierPref, updateFinancierPref } from "http/fundLync/financier.helper";
import ToastDialog from "components/Common/ToastDialog";
import { useNavigate } from "react-router-dom";
import * as PropTypes from 'prop-types';

const AddFinPreference = () => {
    document.title = "Financier Preference | FundLync"

    const navigate = useNavigate();
    const [editPreference, setEditPreference] = useState(false);
    const user = decryptedValue(localStorage.getItem("user"));
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
    const [prefrence, setPrefrence] = useState()
    const [dropdownValues, setDropdownValues] = useState()
    const [selectedRating, setSelectedRating] = useState()
    const [selectedFinancier, setSelectedFinancier] = useState()
    const [selectedProducts, setSelectedProducts] = useState()
    const [selectedGeographies, setSelectedGeographies] = useState()
    const [selectedPreferredIndustries, setSelectedPreferredIndustries] = useState()
    const [selectedNegativeIndustries, setSelectedNegativeIndustries] = useState()

    useEffect(() => {
        fetchAllDropDownValue()
        const urlParams = new URLSearchParams(window.location.search);
        const encodedId = urlParams.get("id");

        if (encodedId) {
            const decodedId = atob(encodedId);
            setEditPreference(true)
            fetchFinPreferenceData(decodedId)
        }

        if(!editPreference){
        validation.setFieldValue('products',[{
            id: uId(),
            productID: "",
            productType: "",
            minPriceRange: "",
            maxPriceRange: "",
            minSanctionAmt: "",
            maxSanctionAmt: "",
        }])
    }

    }, [])

    useEffect(() => {
        if (editPreference && dropdownValues && prefrence) {
            setSelectedRating(dropdownValues['Ratings']?.map((obj) => {
                return {
                    label: obj.displayName, value: obj.dropdownValue
                }
            })
                .find((obj) => obj.value == prefrence.minimumRating))

        }
    }, [dropdownValues,prefrence])


    const fetchAllDropDownValue = () => {
        const dropDownName = ['Ratings', 'Geographical Values', 'Product Type']

        const listOfDropDown = dropDownName.map((obj) => { return { 'dropdownName': obj } });
        const requestList = listOfDropDown.map((obj) => getDropDownList(obj));

        requestList.push(allFinancier())
        requestList.push(getIndustry())

        getAllDropDownValues(requestList)
            .then((result) => {
                const filterResult = {}

                dropDownName.forEach((name, index) => {
                    const { status, code, data } = result[index]
                    const values = (status && code == 200) ? data.rows[0] : {}
                    filterResult[name] = values.dropdownValues || []
                });

                filterResult['Financier'] = result[3]?.data || []
                filterResult['Industry'] = result[4]?.data || []

                setDropdownValues(filterResult)



            }).catch((error) => {
                console.error(error)
            });
    }

    const fetchFinPreferenceData = (id) => {
        getFinancierPref({ id })
            .then((result) => {
                const { status, data } = result
                if (status) {

                    try {

                        const products = JSON.parse(JSON.stringify(data.products))
                        const coveredGeography = JSON.parse(JSON.stringify(data.coveredGeography))
                        const dataObj = {
                            financierId: data.financier.id,
                            minimumRating: data.minimumRating,
                            negativeIndustries: data.negativeIndustries.map((obj) => obj.id),
                            preferredIndustries: data.preferredIndustries.map((obj) => obj.id),
                            products: products.map((obj) => Object.assign(obj, { id: uId(), productID: obj.productID[0].dropdownValue, productType: obj.productType[0].dropdownValue, subProduct: obj.subProduct|| []})),
                            geographicalValue: coveredGeography.map((obj)=>obj.dropdownValue),
                            payoutToCi: data.payoutToCi,
                            integrationWithCi: data.integrationWithCi,
                            maxTurnOver: data.maxTurnOver,
                            minTurnOver: data.minTurnOver,
                        }
                        setPrefrence(dataObj)
                        setSelectedProducts(data.products)
                        setSelectedFinancier({
                            label: data.financier.entityName,
                            value: data.financier.id,
                        })
                        setSelectedPreferredIndustries(data.preferredIndustries?.map((obj) => {
                            return {
                                label: obj.industryName, value: obj.id
                            }
                        }))
                        setSelectedNegativeIndustries(data.negativeIndustries?.map((obj) => {
                            return {
                                label: obj.industryName, value: obj.id
                            }
                        }))



                        setSelectedGeographies(data.coveredGeography?.map((obj) => {
                            return {
                                label: obj.displayName, value: obj.dropdownValue
                            }
                        })
                        )
                    } catch (error) {
                        console.log(error);
                    }
                }

            }).catch((error) => {
                console.error(error)
            });
    }


    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            financierId: prefrence?.financierId || '',
            minimumRating: prefrence?.minimumRating || '',
            minTurnOver: prefrence?.minTurnOver || '',
            maxTurnOver: prefrence?.maxTurnOver || '',
            negativeIndustries: prefrence?.negativeIndustries || [],
            preferredIndustries: prefrence?.preferredIndustries || [],
            products: prefrence?.products || [],
            geographicalValue: prefrence?.geographicalValue || '',
            payoutToCi: prefrence?.payoutToCi || '',
            integrationWithCi: prefrence?.integrationWithCi || '',

        },
        validationSchema: Yup.object({
            financierId: Yup.string().required("Select valid fiancier"),
            minimumRating: Yup.string().required("Select valid rating"),
            negativeIndustries: Yup.array().of(Yup.string()),
            preferredIndustries: Yup.array().of(Yup.string()).min(1, 'Atleast 1 preference required'),
            products: Yup.array().of(
                Yup.object({
                    id: Yup.string(),
                    productID: Yup.string().required('Select valid product'),
                    productType: Yup.string().required('Select valid product'),
                    minPriceRange: Yup.number().typeError("ROI must be a number")
                        .min(1, "Min ROI should be 1")
                        .max(100, "Max ROI can not exceed 100")
                        .test('minValueTest', "Value must be less than Max ROI", function (value) {
                            const allValues = this.parent
                            return !allValues.maxPriceRange || allValues.maxPriceRange >= value
                        }).required('Enter min ROI'),
                    maxPriceRange: Yup.number().typeError("ROI must be a number")
                        .min(1, "Min ROI should be 1")
                        .max(100, "Max ROI can not exceed 100")
                        .test('maxValueTest', "Value must be greater than Min ROI", function (value) {
                            const allValues = this.parent
                            return !allValues.minPriceRange || allValues.minPriceRange <= value
                        })
                        .required('Enter max ROI'),
                    minSanctionAmt: Yup.number().typeError("Min sanction amount must be a number")
                        .min(1, "Min Sanction amount should be 1")
                        .test('minSanctionAmt', "Value must be less than Max Sanction Amount", function (value) {
                            const allValues = this.parent
                            return !allValues.maxSanctionAmt || allValues.maxSanctionAmt >= value
                        }).required('Enter Min sanction amount allowed'),
                    maxSanctionAmt: Yup.number().typeError("Max sanction amount must be a number")
                        .min(1, "Max Sanction amount should be 2")
                        .test('maxSanctionAmt', "Value must be greater than Min Sanction Amount", function (value) {
                            const allValues = this.parent
                            return !allValues.minSanctionAmt || allValues.minSanctionAmt <= value
                        }).required('Enter Max sanction amount allowed'),
                })
            ).min(1, 'Atleast 1 product required'),
            geographicalValue: Yup.array().of(Yup.string()).min(1, 'Atleast 1 Geo graphical required').required("Select valid geographical value"),
            payoutToCi: Yup.number().typeError("Payout to CI must be a number").min(0, "Min payout should be greater than 0")
                .max(100, "Max payout can not exceed 100").required("Enter valid payout"),
            integrationWithCi: Yup.mixed().oneOf(['yes', 'no'], 'Select valid integration').required("Select Yes or No"),
            minTurnOver: Yup.number().typeError("Minimum turnover amount must be a number")
                .min(1, "Minimum turnover amount should be greater than 0")
                .test('minTurnOver', "Value must be less than maximum turnover amount", function (value) {
                    const { maxTurnOver } = this.parent;
                if (value && maxTurnOver) {
                    return value < maxTurnOver;
                }
                return true;
                }),
            maxTurnOver: Yup.number().typeError("Maximum turnover amount must be a number")
                .min(1, "Maximum turnover amount should be greater than 0")
                .test('maxTurnOver', "Value must be greater than minimum turnover amount", function (value) {
                    const { minTurnOver } = this.parent;
                if (value && minTurnOver) {
                    return value > minTurnOver;
                }
                return true;
                }),
        }),
        onSubmit: (values) => {
            const message = editPreference ? 'Are you sure want to update this Preference?' : 'Are you sure want to submit this Preference?'
            setShowCommonDialog({ isShow: true, data: { type: editPreference ? 'update' : 'add' }, message })
        },
    });
    const debounce = (func, delay) => {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            func(...args);
          }, delay);
        };
      };

      
      const handleInputChange = useCallback(
        debounce((value) => {
          allFinancier({ searchKey: value })
            .then((response) => {
              if (response?.data) {
                setDropdownValues((prevDropdownValues) =>
                  Object.assign({}, prevDropdownValues, { Financier: response.data })
                );
              } else {
                setDropdownValues((prevDropdownValues) =>
                  Object.assign({}, prevDropdownValues, { Financier: [] })
                );
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }, 400),
        []
      );
        
    const setValidationValue = (key, value) => {

        validation.setFieldValue(key, value);

    };


    const handleDelete = (rowIndex) => {
        validation.values.products.splice(rowIndex, 1);
        validation.validateForm();
    };

    const handleItemSelect = (data, value) => {
        data.type = value;
        validation.setFieldValue("type", value);
    };

    const onProductTypeChange = (value) => {
        if (!value || !dropdownValues || dropdownValues[value]?.length > 0)
            return;

        const dropDownName = [value]

        const listOfDropDown = dropDownName.map((obj) => { return { 'dropdownName': obj } });
        const requestList = listOfDropDown.map((obj) => getDropDownList(obj));


        getAllDropDownValues(requestList)
            .then((result) => {
                const filterResult = {}

                dropDownName.forEach((name, index) => {
                    const { status, code, data } = result[index]
                    const values = (status && code == 200) ? data.rows[0] : {}
                    filterResult[name] = values.dropdownValues || []
                });

                setDropdownValues(Object.assign(dropdownValues, filterResult))
                validation.validateField('products')
            }).catch((error) => {
                console.error(error)
            });
    }

    const dialogAction = (action, data) => {

        if (data.type == 'add' && action == 1) {
            setShowCommonDialog({ isShow: false })
            submitFinancierPreference();
        } else if (data.type == 'update' && action == 1) {
            setShowCommonDialog({ isShow: false })
            updateFinancierPreference()
        } else {

            setShowCommonDialog({ isShow: false })
        }
    }

    const submitFinancierPreference = () => {
        const values = validation.values
        const postValues = {
            "financierId": values.financierId,
            "negativeIndustries": values.negativeIndustries,
            "preferredIndustries": values.preferredIndustries,
            "minimumRating": values.minimumRating,
            "minTurnOver": values.minTurnOver,
            "maxTurnOver": values.maxTurnOver,
            "products": values.products.map((obj) => {
                return {
                    "productType": obj.productType,
                    "productID": obj.productID,
                    "subProduct": obj.subProduct,
                    "minPriceRange": parseInt(obj.minPriceRange),
                    "maxPriceRange": parseInt(obj.maxPriceRange),
                    "minSanctionAmt": parseInt(obj.minSanctionAmt),
                    "maxSanctionAmt": parseInt(obj.maxSanctionAmt),
                   
                  }
            }),
            "geographicalValue": values.geographicalValue,
            "payoutToCi": values.payoutToCi,
            "integrationWithCi": values.integrationWithCi
        }
        submitFinancierPref(postValues)
            .then((result) => {
                const { status } = result
                if (status) {
                    setToastInfo({
                        message: "Preference submitted successfully",
                        showToast: true,
                        role: "success",
                    })

                    navigateToListItem()


                }
            }).catch((e) => {

            })
    }



    const updateFinancierPreference = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const encodedId = urlParams.get("id");
        const decodedId = atob(encodedId);
        const values = validation.values
        const postValues = {
            "id": decodedId,
            "financierId": values.financierId,
            "negativeIndustries": values.negativeIndustries,
            "preferredIndustries": values.preferredIndustries,
            "minimumRating": values.minimumRating,
            "minTurnOver": values.minTurnOver || '',
            "maxTurnOver": values.maxTurnOver || '',
            "products": values.products.map((obj) => {
                return {
                    "productType": obj.productType,
                    "productID": obj.productID,
                    "subProduct": obj.subProduct,
                    "minPriceRange": parseInt(obj.minPriceRange),
                    "maxPriceRange": parseInt(obj.maxPriceRange),
                    "minSanctionAmt": parseInt(obj.minSanctionAmt),
                    "maxSanctionAmt": parseInt(obj.maxSanctionAmt),
                }
            }),
            "geographicalValue": values.geographicalValue,
            "payoutToCi": values.payoutToCi,
            "integrationWithCi": values.integrationWithCi
        }
        updateFinancierPref(postValues)
            .then((result) => {
                const { status } = result
                if (status) {
                    setToastInfo({
                        message: "Preference submitted successfully",
                        showToast: true,
                        role: "success",
                    })

                    navigateToListItem()


                }
            }).catch((e) => {

            })
    }

    const navigateToListItem = () => {
        navigate(`/${user.roleName}/financer-preference`);
    };




    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Add Financier Preference" />
            <Row className="vertical-scroll">
              <Col xs="12">
                <div>
                  <div>
                    {/* <div className="d-flex flex-column">
                                        <div>
                                            <h5 style={{ marginTop: "1%" }}>Financier Deal Preference Details</h5>
                                        </div>
                                    </div> */}
                    <div>
                      {
                        <FormikProvider value={validation}>
                          <Form
                            onSubmit={(e) => {
                              e.preventDefault();
                              validation.handleSubmit();
                              return false;
                            }}
                            className=""
                          >
                            {dropdownValues && (
                              <Row>
                                <Col lg="6" sm="12">
                                  <Label className="form-label mt-4">
                                    Financier*
                                  </Label>
                                  <Select
                                    options={dropdownValues["Financier"]?.map(
                                      (option) => ({
                                        label: option.entityName,
                                        value: option.id,
                                      })
                                    )}
                                    className={`select-dropdown ${
                                      validation.touched.financierId &&
                                      validation.errors.financierId
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    name="financier"
                                    id="financier"
                                    placeholder={"Select Financier"}
                                    value={selectedFinancier}
                                    onInputChange={handleInputChange}
                                    onChange={(selectedOption) => {
                                      setSelectedFinancier(selectedOption);
                                      setValidationValue(
                                        "financierId",
                                        selectedOption?.value
                                      );
                                    }}
                                    isDisabled={editPreference}
                                  />
                                  {editPreference}
                                  {validation.touched.financierId &&
                                    validation.errors.financierId && (
                                      <FormFeedback>
                                        {validation.errors.financierId}
                                      </FormFeedback>
                                    )}
                                </Col>
                                <Col lg="6" sm="12">
                                  <Label className="form-label mt-4">
                                    Minimum Rating Requirement*
                                  </Label>
                                  <Select
                                    options={dropdownValues["Ratings"].map(
                                      (option) => ({
                                        label: option.displayName,
                                        value: option.dropdownValue,
                                      })
                                    )}
                                    className={`select-dropdown ${
                                      validation.touched.minimumRating &&
                                      validation.errors.minimumRating
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    name="minimumRating"
                                    id="minimumRating"
                                    placeholder={"Select Min Rating"}
                                    value={selectedRating}
                                    // onInputChange={handleInputChange}
                                    onChange={(selectedOption) => {
                                      setSelectedRating(selectedOption);
                                      setValidationValue(
                                        "minimumRating",
                                        selectedOption?.value
                                      );
                                    }}
                                  />
                                  {validation.touched.minimumRating &&
                                    validation.errors.minimumRating && (
                                      <FormFeedback>
                                        {validation.errors.minimumRating}
                                      </FormFeedback>
                                    )}
                                </Col>
                                <Col lg="6" sm="12">
                                  <Label className="form-label mt-4">
                                    Geographies Covered*
                                  </Label>
                                  <Select
                                    options={dropdownValues[
                                      "Geographical Values"
                                    ].map((option) => ({
                                      label: option.displayName,
                                      value: option.dropdownValue,
                                    }))}
                                    className={`select-dropdown ${
                                      validation.touched.geographicalValue &&
                                      validation.errors.geographicalValue
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    name="geographicalValue"
                                    id="geographicalValue"
                                    isMulti={true}
                                    placeholder={"Select Geographies"}
                                    value={selectedGeographies}
                                    // onInputChange={handleInputChange}
                                    onChange={(selectedOption) => {
                                      setSelectedGeographies(selectedOption);
                                      setValidationValue(
                                        "geographicalValue",
                                        selectedOption?.map((obj) => obj?.value)
                                      );
                                    }}
                                  />
                                  {validation.touched.geographicalValue &&
                                    validation.errors.geographicalValue && (
                                      <FormFeedback>
                                        {validation.errors.geographicalValue}
                                      </FormFeedback>
                                    )}
                                </Col>
                                <Col sm="12" md="6">
                                  <Label className="form-label mt-4">
                                    Payout to CI (In %)*
                                  </Label>
                                  <Input
                                    name="payoutToCi"
                                    type="text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.payoutToCi || ""}
                                    invalid={
                                      validation.touched.payoutToCi &&
                                      validation.errors.payoutToCi
                                    }
                                  />
                                  {validation.touched.payoutToCi &&
                                  validation.errors.payoutToCi ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.payoutToCi}
                                    </FormFeedback>
                                  ) : null}
                                </Col>

                                <Col sm="12" md="6">
                                  <Label className="form-label mt-4">
                                    Minimum Turnover (₹)
                                  </Label>
                                  <Input
                                    name="minTurnOver"
                                    type="text"
                                    placeholder="Enter minimum turnover expectation"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.minTurnOver || ""}
                                    invalid={
                                      validation.touched.minTurnOver &&
                                      validation.errors.minTurnOver
                                    }
                                  />
                                  {validation.touched.minTurnOver &&
                                  validation.errors.minTurnOver ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.minTurnOver}
                                    </FormFeedback>
                                  ) : null}
                                </Col>
                                <Col sm="12" md="6">
                                  <Label className="form-label mt-4">
                                    Maximum Turnover (₹)
                                  </Label>
                                  <Input
                                    name="maxTurnOver"
                                    type="text"
                                    placeholder="Enter maximum turnover expectation"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.maxTurnOver || ""}
                                    invalid={
                                      validation.touched.maxTurnOver &&
                                      validation.errors.maxTurnOver
                                    }
                                  />
                                  {validation.touched.maxTurnOver &&
                                  validation.errors.maxTurnOver ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.maxTurnOver}
                                    </FormFeedback>
                                  ) : null}
                                </Col>

                                <Col sm="12" md="6">
                                  <div className="d-flex flex-column">
                                    {" "}
                                    <Label className="form-label mt-4">
                                      Integration with CI*
                                    </Label>
                                    <div
                                      className="control-group"
                                      id="integrationCIGroup"
                                    >
                                      <div className="controls mb-1 d-flex">
                                        <div className="form-check mb-2">
                                          <input
                                            type="radio"
                                            id="integrationYes"
                                            name="toastType"
                                            className="form-check-input"
                                            value="yes"
                                            onChange={(ele) => {
                                              validation.setFieldValue(
                                                "integrationWithCi",
                                                ele.target.value
                                              );
                                            }}
                                            checked={
                                              validation.values
                                                .integrationWithCi == "yes"
                                            }
                                          />
                                          <Label
                                            className="form-check-label"
                                            htmlFor="integrationYes"
                                          >
                                            Yes
                                          </Label>
                                        </div>

                                        <div className="form-check mb-2 ms-3">
                                          <input
                                            type="radio"
                                            id="integrationNo"
                                            name="toastType"
                                            className="form-check-input"
                                            value="no"
                                            onChange={(ele) => {
                                              validation.setFieldValue(
                                                "integrationWithCi",
                                                ele.target.value
                                              );
                                            }}
                                            checked={
                                              validation.values
                                                .integrationWithCi == "no"
                                            }
                                          />
                                          <Label
                                            className="form-check-label"
                                            htmlFor="radio2"
                                          >
                                            No
                                          </Label>
                                        </div>
                                      </div>
                                    </div>
                                    {validation.touched.integrationWithCi &&
                                      validation.errors.integrationWithCi && (
                                        <p
                                          className="font-size-11"
                                          style={{
                                            marginTop: "-5px",
                                            color: "rgb(245,116,116)",
                                          }}
                                        >
                                          {validation.errors.integrationWithCi}
                                        </p>
                                      )}
                                  </div>
                                </Col>
                                <Col sm="12" md="6"></Col>
                                <Col lg="6" sm="12">
                                  <Label className="form-label mt-4">
                                    Preferred Industries*
                                  </Label>
                                  <Select
                                    options={dropdownValues["Industry"]
                                      ?.map((option) => ({
                                        label: option.industryName,
                                        value: option.id,
                                      }))
                                      ?.filter(
                                        (obj) =>
                                          validation.values.negativeIndustries?.filter(
                                            (o) => o == obj.value
                                          )?.length == 0
                                      )}
                                    className={`select-dropdown ${
                                      validation.touched.preferredIndustries &&
                                      validation.errors.preferredIndustries
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    name="preferredIndustries"
                                    id="preferredIndustries"
                                    isMulti={true}
                                    placeholder={"Select Preferred Industries"}
                                    value={selectedPreferredIndustries}
                                    // onInputChange={handleGenericInputChange}
                                    onChange={(selectedOption) => {
                                      setSelectedPreferredIndustries(
                                        selectedOption
                                      );
                                      setValidationValue(
                                        "preferredIndustries",
                                        selectedOption?.map((obj) => obj?.value)
                                      );
                                    }}
                                  />
                                  {validation.touched.preferredIndustries &&
                                    validation.errors.preferredIndustries && (
                                      <FormFeedback>
                                        {validation.errors.preferredIndustries}
                                      </FormFeedback>
                                    )}
                                </Col>
                                <Col lg="6" sm="12">
                                  <Label className="form-label mt-4">
                                    Negative Industries
                                  </Label>
                                  <Select
                                    options={dropdownValues["Industry"]
                                      ?.map((option) => ({
                                        label: option.industryName,
                                        value: option.id,
                                      }))
                                      ?.filter(
                                        (obj) =>
                                          validation.values.preferredIndustries?.filter(
                                            (o) => o == obj.value
                                          )?.length == 0
                                      )}
                                    className={`select-dropdown ${
                                      validation.touched.negativeIndustries &&
                                      validation.errors.negativeIndustries
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    name="negativeIndustries"
                                    id="negativeIndustries"
                                    isMulti={true}
                                    placeholder={"Select Negative Industries"}
                                    value={selectedNegativeIndustries}
                                    // onInputChange={handleGenericInputChange}
                                    onChange={(selectedOption) => {
                                      setSelectedNegativeIndustries(
                                        selectedOption
                                      );
                                      setValidationValue(
                                        "negativeIndustries",
                                        selectedOption?.map((obj) => obj?.value)
                                      );
                                    }}
                                  />
                                  {validation.touched.negativeIndustries &&
                                    validation.errors.negativeIndustries && (
                                      <FormFeedback>
                                        {validation.errors.negativeIndustries}
                                      </FormFeedback>
                                    )}
                                </Col>
                                <Col sm="12">
                                  <h4 className="form-label mt-4">Products</h4>
                                  <FieldArray
                                    name="products"
                                    render={(arrayHelpers) => (
                                      <>
                                        {validation.values.products.map(
                                          (product, index) => (
                                            <TableRow
                                              key={product.id}
                                              onDelete={handleDelete}
                                              onItemSelect={handleItemSelect}
                                              index={index}
                                              products={selectedProducts}
                                              dropDownValues={dropdownValues}
                                              validation={validation}
                                              onProductTypeChange={
                                                onProductTypeChange
                                              }
                                              isEditMode={editPreference}
                                              
                                            />
                                          )
                                        )}
                                        <Row>
                                          <Col xs="12">
                                            <span
                                              className="text-success"
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                arrayHelpers.push({
                                                  id: uId(),
                                                  productID: "",
                                                  productType: "",
                                                  minPriceRange: "",
                                                  maxPriceRange: "",
                                                  minSanctionAmt: "",
                                                  maxSanctionAmt: "",
                                                });
                                              }}
                                            >
                                              <i className="mdi mdi-plus me-1" />{" "}
                                              Add Product
                                            </span>
                                          </Col>
                                        </Row>
                                      </>
                                    )}
                                  />
                                </Col>

                                <Col sm="12">
                                  <div className="mt-3 d-flex justify-content-end">
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary save-customer me-3"
                                      onClick={() => navigateToListItem()}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="submit"
                                      className="btn btn-success save-customer"
                                    >
                                      {editPreference ? "Update" : "Submit"}
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </Form>
                        </FormikProvider>
                      }
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        {showCommonDialog && (
          <CommonDialog
            isShow={showCommonDialog.isShow}
            message={showCommonDialog.message}
            data={showCommonDialog.data}
            postitiveBtn={"Submit"}
            negativeBtn={"Close"}
            onCloseFn={dialogAction}
          ></CommonDialog>
        )}
        <ToastDialog
          message={toastInfo.message || ""}
          showToast={toastInfo.showToast}
          role={toastInfo.role}
          onCloseFn={() => setToastInfo({ showToast: false })}
        ></ToastDialog>
      </React.Fragment>
    );
}

const TableRow = ({ dropDownValues, index, validation, products, onDelete, onItemSelect, onProductTypeChange,isEditMode}) => {
  const [productType, setProductType] = useState(() => {
    if (isEditMode && products?.[index]?.productType) {
      if (products || products[index]) {
           return (
        
            products[index].productType?.map((option) => ({
              label: option.displayName,
              value: option.dropdownValue,
          })).find((obj) => obj.value == validation.values.products[index].productType) || null
      );
      }
     
    }
    return null; // Set to empty state when not in edit mode
  });
    const [product, setProduct] = useState();
    const [isProductSelected, setIsProductSelected] = useState(false);
    const [subProductList, setSubProductList] = useState([]);
    const [isShowSubProduct, setIsShowSubProduct] = useState(false);
    const [selectedMultiSubProduct, setSelectedMultiSubProduct] = useState(
      validation.values.productInfoList?.[index]?.subProduct || []
    );
    const handleMultiSubProductChange = (selectedOptions) => {
      setSelectedMultiSubProduct(selectedOptions);
      const newData = selectedOptions.map(ele => ele.value); // Get the selected subproduct IDs
      handleInputChange(index, "subProduct", newData); // Update the form state with the selected IDs
  };
  //   useEffect(() => {
  //     if (!products || !products[index]) return;
  //     // if(editPreference){
  //       setProductType(products[index].productType?.map((option) => ({
  //         label: option.displayName,
  //         value: option.dropdownValue,
  //     })).find((obj) => obj.value == validation.values.products[index].productType));
  //     // }
      
  // }, [products, index, validation]);

    useEffect(() => {
        if (!productType)
        return;

        setProduct(dropDownValues[productType.value]?.map((option) => ({
            label: option.displayName,
            value: option.dropdownValue,
        })).find((obj)=>obj.value==validation.values.products[index].productID))
    }, [productType, validation, index, dropDownValues]);

    useEffect(() => {
      if(isEditMode) {
        if (!product) return;

        // Fetch sub-products based on the selected product type
        getDropDownList({ dropdownName: product.value })
            .then((response) => {
                const dropdownValues = response.data?.rows?.find(dv => dv.dropdownName === product.value)?.dropdownValues || [];
                setSubProductList(dropdownValues.map(option => ({
                    label: option.displayName,
                    value: option.dropdownValue,
                })));
                const existingSubProducts = validation.values.products[index]?.subProduct || [];
                setSelectedMultiSubProduct(existingSubProducts.map(subProductId => ({
                    label: dropdownValues.find(sub => sub.dropdownValue === subProductId)?.displayName,
                    value: subProductId,
                })));
            })
            .catch((error) => {
                console.error(error);
            });
      }
  }, [product, validation.values.products, index]);

    useEffect(() => {
        if(!productType)
            return
        if (productType && !dropDownValues[productType.value])
            onProductTypeChange(productType.value)
    }, [productType,onProductTypeChange])

    const handleInputChange = (index, field, value) => {
        validation.setFieldValue(`products.${index}.${field}`, value);
    };

    return (
      <Row className="mb-3 mt-2 align-items-start">
        <Col
          xs="12"
          md="24"
          className="d-flex justify-content-end align-items-start mt-4"
        >
          {validation.values?.products?.length > 1 && (
            <i
              className="bx bx-x-circle text-danger"
              onClick={() => onDelete(index)}
              style={{ cursor: "pointer", fontSize: "20px" }}
            />
          )}
        </Col>
        <Col
          xs="12"
          md="2"
          className="d-flex flex-column justify-content-start mt-4"
        >
          <Label className="form-label text-dark text-truncate">
            Product Type *
          </Label>
          <Select
            options={dropDownValues["Product Type"].map((option) => ({
              label: option.displayName,
              value: option.dropdownValue,
            }))}
            className={`${
              validation.touched.products?.[index]?.productType &&
              validation.errors.products?.[index]?.productType
                ? "is-invalid"
                : ""
            }`}
            name={`product[${index}].productType`}
            id={`product[${index}].productType`}
            onChange={(selectedOption) => {
              setProductType(selectedOption);
              setProduct(null);
              handleInputChange(index, "productType", selectedOption?.value);
              onProductTypeChange(selectedOption?.value);
              setIsProductSelected(false);
            }}
            value={productType}
          />
          {validation.touched.products?.[index]?.productType &&
            validation.errors.products?.[index]?.productType && (
              <FormFeedback>
                {validation.errors.products?.[index]?.productType}
              </FormFeedback>
            )}
        </Col>
        <Col
          xs="12"
          md="2"
          className="d-flex flex-column justify-content-start mt-4"
        >
          <Label className="form-label text-dark text-truncate">
            Product *
          </Label>
          <Select
            options={dropDownValues[productType?.value]?.map((option) => ({
              label: option.displayName,
              value: option.dropdownValue,
            }))}
            className={`${
              validation.touched.products?.[index]?.productID &&
              validation.errors.products?.[index]?.productID
                ? "is-invalid"
                : ""
            }`}
            name={`product[${index}].productID`}
            id={`product[${index}].productID`}
            onChange={(selectedOption) => {
              setProduct(selectedOption);
              handleInputChange(index, "productID", selectedOption?.value);
              setIsProductSelected(true);
              setIsShowSubProduct(true);
            }}
            value={product}
          />
          {validation.touched.products?.[index]?.productID &&
            validation.errors.products?.[index]?.productID && (
              <FormFeedback>
                {validation.errors.products?.[index]?.productID}
              </FormFeedback>
            )}
        </Col>
        {(isEditMode || (isProductSelected && isShowSubProduct)) && subProductList.length > 0 && (
          <Col
            xs="12"
            md="2"
            className="d-flex flex-column justify-content-start mt-4"
          ><Label className="form-label text-dark text-truncate">
                Select Sub Product*
              </Label>
              <Select
                name={`file[${index}].subProduct`}
                id={`file[${index}].subProduct`}
                value={selectedMultiSubProduct}
                isMulti={true}
                onChange={handleMultiSubProductChange}
                options={subProductList}
                className="select2-selection mb-2"
                onBlur={() => validation.setFieldTouched(`productInfoList[${index}].subProduct`, true)}
              />
              {validation.touched.productInfoList?.[index]?.subProduct &&
                validation.errors.productInfoList?.[index]?.subProduct ? (
                <p style={{ color: "rgb(245,116,116)", fontSize: "11px" }}>
                  {validation.errors.productInfoList?.[index]?.subProduct}
                </p>
              ) : null}
            </Col>
          )}

        <Col
          xs="12"
          md="2"
          className="d-flex flex-column justify-content-start mt-4"
        >


          <Label className="form-label text-dark text-truncate">
            Min ROI (in %)*
          </Label>
          <Input
            type="text"
            placeholder="Enter Min ROI"
            name={`product[${index}].minPriceRange`}
            id={`product[${index}].minPriceRange`}
            value={validation.values.products[index].minPriceRange}
            onChange={(e) =>
              handleInputChange(index, "minPriceRange", e.target.value)
            }
            invalid={
              validation.touched.products?.[index]?.minPriceRange &&
              validation.errors.products?.[index]?.minPriceRange
            }
          />
          {validation.touched.products?.[index]?.minPriceRange &&
            validation.errors.products?.[index]?.minPriceRange && (
              <FormFeedback>
                {validation.errors.products[index].minPriceRange}
              </FormFeedback>
            )}
        </Col>
        <Col
          xs="12"
          md="2"
          className="d-flex flex-column justify-content-start mt-4"
        >
          <Label className="form-label text-dark text-truncate">
            Max ROI (in %)*
          </Label>
          <Input
            type="text"
            placeholder="Enter Max ROI"
            name={`product[${index}].maxPriceRange`}
            id={`product[${index}].maxPriceRange`}
            value={validation.values.products[index].maxPriceRange}
            onChange={(e) =>
              handleInputChange(index, "maxPriceRange", e.target.value)
            }
            invalid={
              validation.touched.products?.[index]?.maxPriceRange &&
              validation.errors.products?.[index]?.maxPriceRange
            }
          />
          {validation.touched.products?.[index]?.maxPriceRange &&
            validation.errors.products?.[index]?.maxPriceRange && (
              <FormFeedback>
                {validation.errors.products[index].maxPriceRange}
              </FormFeedback>
            )}
        </Col>
        <Col
          xs="12"
          md="2"
          className="d-flex flex-column justify-content-start mt-4"
        >
          <Label className="form-label text-dark text-truncate">
            Min Sanction Amount*
          </Label>
          <Input
            type="text"
            placeholder="Enter Min Sanction Amount"
            name={`product[${index}].minSanctionAmt`}
            id={`product[${index}].minSanctionAmt`}
            value={validation.values.products[index].minSanctionAmt}
            onChange={(e) =>
              handleInputChange(index, "minSanctionAmt", e.target.value)
            }
            invalid={
              validation.touched.products?.[index]?.minSanctionAmt &&
              validation.errors.products?.[index]?.minSanctionAmt
            }
          />
          {validation.touched.products?.[index]?.minSanctionAmt &&
            validation.errors.products?.[index]?.minSanctionAmt && (
              <FormFeedback>
                {validation.errors.products[index].minSanctionAmt}
              </FormFeedback>
            )}
        </Col>

        <Col
          xs="12"
          md="2"
          className="d-flex flex-column justify-content-start mt-4"
        >
          <Label className="form-label text-dark text-truncate">
            Max Sanction Amount*
          </Label>
          <Input
            type="text"
            placeholder="Enter Max Sanction Amount"
            name={`product[${index}].maxSanctionAmt`}
            id={`product[${index}].maxSanctionAmt`}
            value={validation.values.products[index].maxSanctionAmt}
            onChange={(e) =>
              handleInputChange(index, "maxSanctionAmt", e.target.value)
            }
            invalid={
              validation.touched.products?.[index]?.maxSanctionAmt &&
              validation.errors.products?.[index]?.maxSanctionAmt
            }
          />
          {validation.touched.products?.[index]?.maxSanctionAmt &&
            validation.errors.products?.[index]?.maxSanctionAmt && (
              <FormFeedback>
                {validation.errors.products[index].maxSanctionAmt}
              </FormFeedback>
            )}
        </Col>
      </Row>
    );
      

};

TableRow.propTypes = {
    dropDownValues: PropTypes.any,
    index: PropTypes.number,
    validation: PropTypes.any,
    products: PropTypes.any,
    onDelete: PropTypes.func,
    onItemSelect: PropTypes.func,
    onProductTypeChange: PropTypes.func
}


export default AddFinPreference;